export const DATA_FECHAMENTO_CONSUMO = "2022-06-01";
